import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { useControllableState } from '@radix-ui/react-use-controllable-state';
import { useState } from 'react';
import { DropdownAnchor } from './components/anchor/Anchor.mjs';
import { DropdownCheckboxItem } from './components/checkbox-item/CheckboxItem.mjs';
import { DropdownContentAffix } from './components/content-affix/ContentAffix.mjs';
import { DropdownContentFooter } from './components/content-footer/ContentFooter.mjs';
import { DropdownContent } from './components/content/Content.mjs';
import { DropdownGroupTitle } from './components/group-title/GroupTitle.mjs';
import { DropdownGroup } from './components/group/Group.mjs';
import { DropdownItemDescription } from './components/item-description/ItemDescription.mjs';
import { DropdownItemIndicator } from './components/item-indicator/ItemIndicator.mjs';
import { DropdownItemTitle } from './components/item-title/ItemTitle.mjs';
import { DropdownItem } from './components/item/Item.mjs';
import { DropdownLabel } from './components/label/Label.mjs';
import { DropdownRadioGroup } from './components/radio-group/RadioGroup.mjs';
import { DropdownRadioItem } from './components/radio-item/RadioItem.mjs';
import { DropdownSeparator } from './components/separator/Separator.mjs';
import { DropdownSlot } from './components/slot/Slot.mjs';
import { DropdownSubContent } from './components/sub-content/SubContent.mjs';
import { DropdownSubItem } from './components/sub-item/SubItem.mjs';
import { DropdownSubTriggerIndicator } from './components/sub-trigger-indicator/SubTriggerIndicator.mjs';
import { DropdownSubTrigger } from './components/sub-trigger/SubTrigger.mjs';
import { DropdownTrigger } from './components/trigger/Trigger.mjs';
import { DropdownContextProvider } from './contexts/context.mjs';
import { DropdownMenuSub, DropdownMenu } from './patched-dropdown/Dropdown.mjs';

function Dropdown({
  children,
  open: openFromProps,
  defaultOpen: defaultOpenFromProps,
  onOpenChange,
  onClose,
  modal,
  dir
}) {
  const [open = false, setOpen] = useControllableState({
    prop: openFromProps,
    defaultProp: defaultOpenFromProps,
    onChange: onOpenChange
  });
  const [contentAffixElement, setContentAffixElement] = useState(null);
  const [contentFooterElement, setContentFooterElement] = useState(null);
  return /* @__PURE__ */ jsx(
    DropdownContextProvider,
    {
      open,
      onOpenChange: setOpen,
      onClose,
      contentAffixElement,
      onContentAffixElementChange: setContentAffixElement,
      contentFooterElement,
      onContentFooterElementChange: setContentFooterElement,
      children: /* @__PURE__ */ jsx(DropdownMenu, { open, onOpenChange: setOpen, modal, dir, children })
    }
  );
}
Dropdown.Anchor = styled(DropdownAnchor);
Dropdown.Trigger = styled(DropdownTrigger);
Dropdown.Content = styled(DropdownContent);
Dropdown.ContentAffix = styled(DropdownContentAffix);
Dropdown.ContentFooter = styled(DropdownContentFooter);
Dropdown.Label = styled(DropdownLabel);
Dropdown.Slot = styled(DropdownSlot);
Dropdown.Item = styled(DropdownItem);
Dropdown.ItemTitle = styled(DropdownItemTitle);
Dropdown.ItemDescription = styled(DropdownItemDescription);
Dropdown.ItemIndicator = styled(DropdownItemIndicator);
Dropdown.CheckboxItem = styled(DropdownCheckboxItem);
Dropdown.RadioGroup = styled(DropdownRadioGroup);
Dropdown.RadioItem = styled(DropdownRadioItem);
Dropdown.Group = styled(DropdownGroup);
Dropdown.GroupTitle = styled(DropdownGroupTitle);
Dropdown.Separator = styled(DropdownSeparator);
Dropdown.Sub = styled(DropdownMenuSub);
Dropdown.SubItem = styled(DropdownSubItem);
Dropdown.SubTrigger = styled(DropdownSubTrigger);
Dropdown.SubTriggerIndicator = styled(DropdownSubTriggerIndicator);
Dropdown.SubContent = styled(DropdownSubContent);

export { Dropdown };
//# sourceMappingURL=Dropdown.mjs.map
